import axios from "axios";
import jwtEncode from "jwt-encode";
import { store } from "../Store/store.js";

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

const successResponseInterceptor = (response) => {
  return response?.data?.data;
};

const errorResponseInterceptor = (error) => {
  console.log(error);
  if ((error.status || error.response.status) === 401) {
    const state = store.getState();
    const configData = state.configSlice;
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };
    const token = jwtEncode(payload, "");
    localStorage.removeItem("token");
    window.location.href = `${configData.config.redirectUri}?referrer=${token}`;
    return
  }
  throw error;
};

const requestInterceptor = (req) => {
  const state = store.getState();
  const userData = state.userSlice;
  req.headers.Authorization = `Bearer ${userData.token}`;
  return req;
};

apiClient.interceptors.request.use(requestInterceptor);
apiClient.interceptors.response.use(successResponseInterceptor, errorResponseInterceptor);

export default apiClient;
